import { featuredManga } from '@/mocks/yokaiManga';

export default function Featured() {
  return (
    <section id="hot" className="bg-paper-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-10 flex flex-col gap-2 md:mb-12">
          <p className="text-sm font-medium text-primary-600">人气之作</p>
          <h2 className="font-serif text-2xl font-bold text-ink-900 md:text-3xl">热门推荐</h2>
          <p className="max-w-2xl text-sm text-ink-500 md:text-base">
            精选当下最受读者欢迎的妖精漫画，覆盖狐妖、猫妖、花妖、雪女、河童等热门类型，
            更新同步、点开即看。
          </p>
        </div>

        <div className="grid grid-cols-2 gap-4 lg:grid-cols-4 md:gap-6">
          {featuredManga.map((manga) => (
            <article
              key={manga.id}
              className="group overflow-hidden rounded-2xl border border-paper-200 bg-paper-50 transition-all hover:-translate-y-1"
            >
              <div className="relative w-full overflow-hidden">
                <img
                  src={manga.cover}
                  alt={`${manga.title}妖精漫画封面`}
                  className="h-64 w-full object-cover object-top transition-transform duration-500 group-hover:scale-105 md:h-72"
                />
                <span className="absolute left-3 top-3 rounded-full bg-ink-900/70 px-3 py-1 text-xs font-medium text-accent-200 backdrop-blur-sm">
                  {manga.category}
                </span>
                <span
                  className={`absolute right-3 top-3 rounded-full px-3 py-1 text-xs font-medium ${
                    manga.status === '连载中'
                      ? 'bg-primary-500 text-paper-50'
                      : 'bg-secondary-500 text-paper-50'
                  }`}
                >
                  {manga.status}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-serif text-base font-bold text-ink-900 md:text-lg">{manga.title}</h3>
                <p className="mt-1 text-xs text-ink-400">{manga.author} 著</p>
                <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-ink-500 md:text-sm">
                  {manga.intro}
                </p>
                <div className="mt-3 flex flex-wrap gap-2">
                  {manga.tags.map((tag) => (
                    <span
                      key={tag}
                      className="whitespace-nowrap rounded-full bg-secondary-50 px-2.5 py-1 text-xs text-secondary-700"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="mt-4 flex items-center justify-between border-t border-paper-200 pt-3">
                  <span className="text-xs text-ink-400">共 {manga.chapters} 话</span>
                  <span className="flex items-center gap-1 text-sm font-semibold text-accent-600">
                    <i className="ri-star-fill" aria-hidden="true"></i>
                    {manga.rating}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}